import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const title = 'object - Provided Fields';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "object"
    }}>{`Object`}</h1>
    <p>{`A field that can edit a set of sub-field`}</p>
    <h2 {...{
      "id": "schema"
    }}>{`Schema`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`<fieldName in value>:
  type: object
  label: string? # fieldName to display
  defaultVal: any? # default value
  helperText: string? # text to help user to input
  disabled: boolean? # disable the input, default false
  fields: Fields
`}</code></pre>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: object
    label: my field
    helperText: help
    fields:
      foo:
        type: text
        label: Foo
  \`), [])
  return (
    <div>
      <BaseForm fields={fields} value={value} onChange={setValue}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </div>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      